<template>
  <div>
    <div class="row">
      <div class="col-12 title" style="padding-bottom: 10px;">
        {{ $t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogName', { Language: GetLangName }) }} <span
          style="color: red">*</span>
      </div>
      <div class="col-4 input-container">
        <textbox :title="$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogName', { Language: GetLangName })"
          :ControlId="temp_Value.type" v-model="temp_Value.catalogName"
          :CharLimit="temp_Value.langId == 1252 ? 'CheckEnglishChar' : ''"
          :mandatory="$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogName', { Language: GetLangName }) + $t('lbl_IsRequire')"  style="min-width: 300px;">
        </textbox>
      </div>
    </div>
    <div class="row">
      <div class="col-12 title">
        {{ $t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogFile', { Language: GetLangName }) }} <span
          style="color: red">*</span>
      </div>
      <div class="col-12 title_p" v-html="$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogFile_P')">
      </div>
      <div class="col-12">
        <div class=" input-container">
          <div v-if="!isPdf"> 
            <validation-provider    Name="Pdfname" :rules="{ required: true }" v-slot="validationContext"
              :vid="temp_Value.type + '_Pdf'">
              <b-form-file
                :state="getValidationState(validationContext)"
                class="mb-2"
                accept="application/pdf"
                ref="pdfUpload"
                :placeholder="$t('lbl_EMPBE_InputFile_Placeholder')"
                v-model="pdfData"
                :browse-text="$t('lbl_EMPBE_InputFile_BrowseText')"
                :no-drop-placeholder="$t('lbl_EMPBE_InputFile_NoDropPlaceholder')"
                :drop-placeholder="$t('lbl_EMPBE_InputFile_DropPlaceholder')"
                :id="temp_Value.type" @change="handleFileChange"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ $t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_CatalogFile', { Language: GetLangName }) + $t('lbl_IsRequire') }}
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
          <div v-else class="m-b-15 file-pdf">
            <div class="file-top">
              <i class="fa fa-file-pdf-o txt-primary"></i>
            </div>
            <div class="file-bottom">
              <a target="_blank" :href="temp_Value.fileName" v-if="isPdf && IsShowLink"><button type="button"
                  class="btn br-right btn-outline-primary">
                  {{ $t("lbl_EMPBE_Check") }}
                </button></a>
              <button type="button" class="btn f-right br-right btn-outline-danger" @click="ClearPdfVals">
                {{ $t("Lbl_Clear") }}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>    
  </div>
</template>
<script>
export default {
  props: ['value'],
  data() {
    return {
      temp_Value: this.value,
      pdfData: null,
      IsShowLink:true
    }
  },
  watch: {
    value(newVal) {
      this.temp_Value = newVal;
    },
    temp_Value: {
      handler(newVal) {
        if (newVal.fileName && (!newVal.fileData || !newVal.fileData.length)) {
          this.IsShowLink = true;
        }

        this.$emit("input", newVal);
      }, deep: true
    },
  },
  computed: {
    GetLangName() {
      return this.temp_Value.langId == 1252 ? this.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_Engilsh') : (this.temp_Value.langId == 936 ? this.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_SimplifiedChinese') : this.$t('lbl_EMPBE_ProductInfo_Catalog_CoverCatalog_TraditionalChinese'))
    },
    isPdf() {
      return (this.temp_Value.fileName || this.temp_Value.fileData ) ? true : false;
    }
  },
  mounted() {
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    ClearPdfVals() {
      this.pdfData = null;
      this.temp_Value.fileData = null;
      this.temp_Value.fileName = '';
    },
    handleFileChange(event) {
      this.temp_Value.fileData = event.target.files ?? null;
      this.IsShowLink=false
    },
  }

}
</script>
<style lang="scss" scoped>
.title {
  color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  /* 24px */
  letter-spacing: 0.15px;
  margin-bottom: 8px;
}

.input-container {
  margin-bottom: 16px;
  width: 300px;
}

.title_p {
  margin-bottom: 8px;
  color: var(--on-surface-60, rgba(0, 0, 0, 0.60));
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 21px */
  letter-spacing: 0.15px;
}

ul {
  margin-left: 20px;

  li {
    list-style-type: initial;
  }
}

</style>